<template>
  <TDialog v-model="open">
    <template #content>
      <t-card dialog>
        <t-card-title>
          <t-icon left>{{ icon }}</t-icon>
          <h3 class="tw:sta-heading" v-html="title" />
        </t-card-title>
        <t-card-text class="tw:text-base">
          <slot />
        </t-card-text>
        <t-card-actions class="tw:justify-end">
          <TBtn flat @click="dismiss"> Dismiss </TBtn>
        </t-card-actions>
      </t-card>
    </template>
  </TDialog>
</template>

<script>
import localforage from "localforage";

export default {
  name: "MemoryCard",
  props: {
    storagePrefix: {
      type: String,
      default: "stationa-app",
    },
    storageSuffix: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    version: {
      type: String || Number,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      store: null,
    };
  },
  computed: {
    storageKey() {
      return `${this.storagePrefix}-${this.storageSuffix}`;
    },
  },
  methods: {
    async dismiss() {
      try {
        await this.store.setItem(this.storageKey, this.version);
      } finally {
        this.open = false;
      }
    },
    async getStoredValue() {
      const storedValue = await this.store.getItem(this.storageKey);
      return storedValue;
    },
  },
  async created() {
    this.store = localforage.createInstance({
      name: this.storagePrefix,
    });
    const storedValue = await this.getStoredValue();
    this.open = storedValue < this.version;
  },
};
</script>
